import ColumnType from "backdraft-app/src/data_table/column_type";
import $ from "jquery";

const columnType = new ColumnType();

columnType.configMatcher(config => !!config.edit);

columnType.nodeMatcher(config => ".inline-editable");

columnType.definition((dataTable, config) => ({
  bSortable: false,
  bSearchable: false,
  sTitle: "",
  sClass: "inline-editable",

  mData(source, type, val) {
    return dataTable.collection.get(source);
  },

  mRender() {
    return "";
  }
}));

columnType.renderer(function(cell, config) {
  const disabledMessage = (typeof config.disabledMessage === "function") ? config.disabledMessage.apply(this, [config]) : null;

  let renderDeleteFn;
  // 'renderDelete' can be a boolean or a function that is invoked for each row
  if (typeof config.renderDelete === "function") {
    renderDeleteFn = config.renderDelete;
  } else {
    renderDeleteFn = ((arg) => { return config.renderDelete; });
  }

  if (disabledMessage) {
    const disabledPopup = `data-toggle="popover" data-placement="top" data-trigger="hover" data-content="${disabledMessage.replace(/"/g, '\\"')}"`;
    let span = $(`<i class="material-icons disabled"${disabledPopup}>edit</i>`);

    cell.html(span);
    span.popover();

    if (renderDeleteFn(this.model)) {
      span = $(`<i class="material-icons disabled"${disabledPopup}>delete</i>`);
      cell.append('&nbsp;');
      cell.append(span);
      span.popover();
    }
  } else {
    const mount = $("<div data-mount='inline-edit'>");
    mount.html($("<a>").attr("href", " ").html("<i class='material-icons' data-action='edit'>edit</i>"));

    if (renderDeleteFn(this.model)) {
      mount.append($("<a>").attr("href", " ").html("<i class='material-icons' data-action='delete'>delete</i>"));
    }
    cell.empty().append(mount);
  }

  return cell;
});

export default columnType;
